import { Ng2StateDeclaration } from '@uirouter/angular';

export const adminState: Ng2StateDeclaration = {
    name: 'admin',
    abstract: true,
    parent: 'app',
};



// WEBPACK FOOTER //
// ./src/app/admin/admin.state.ts